import React , {useState, useEffect, useContext} from "react";
import { useNavigate, Link } from "react-router-dom";
import {useCookies} from "react-cookie";
import { ArgContext } from "../../Context/ArgProvider"
import instance from "../../axios_interceptor.js";

import logo from "../../assets/img/wipia.png";
function AdminLogin() {

    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

    // 전역변수 불러오기
    const {argInfo, setArgInfo} = useContext(ArgContext);

    // 쿠키 객체
    const [cookies, setCookie, removeCookie] = useCookies(["loggedIn"]);
    
    // 로그인 정보 data
    const [loginInfo, setLoginInfo] = useState({
          userId: ""
        , userPw: ""
    });

    // 로딩 후 최초 한번
    useEffect(()=> {
        // 아이디 쿠키 저장 여부 확인 후 set
        if(cookies.loggedIn!=null) {
            // 아이디가 있을 경우 set
            if(cookies.loggedIn!="") {
                setLoginInfo({userId:cookies.loggedIn});
            } 
            // 아이디가 없을 경우 쿠키 삭제
            else {
                removeCookie("loggedIn"); 
            }
        }
    }, []);

    // 로그인 처리
    const fn_login = () => {
        // 로그인 통신
        const response = instance.post("/login", { adminId: loginInfo.userId,adminPwd: loginInfo.userPw}, {headers: {"Content-Type": "application/json"}});
        console.log("login start");
        // 통신 결과
        response.then((res) => {console.log("login called");
            // 로그인 성공
            if(res.data.rtnCd=="SUCCESS") {console.log("login SUCCESS");
                // 로그인 성공시 토큰값 localStorage set
                sessionStorage.setItem("token", res.data.rtnAccessToken);
                sessionStorage.setItem("refreshToken", res.data.rtnRefreshToken);
                
                // 토큰값 localStorage 컨텍스트에 set
                setArgInfo({token:sessionStorage.getItem("token"), refreshToken:sessionStorage.getItem("refreshToken"),
                role: 'admin'  // 250526 role 정보 추가
                });
                
                // role 정보도 sessionStorage에 저장
                sessionStorage.setItem("role", 'admin');

                // 로그인 유효 여부 sessionStorage set
                sessionStorage.setItem("loginCk", true);

                // 메인으로 이동
                navigate("/comHisPrivList");
            } 
            // 로그인 실패
            else {
                alert("관리자에게 문의바랍니다.");
            }
        });
    }

    // input 변경 값 set
    const handleChange = (e) => {
		const { value, name } = e.target;
		setLoginInfo({
			...loginInfo, // 기존 객체 복사
			[name]: value, // name 키를 가진 값을 value로 설정
		});
	}

    // ID SAVE 변경 값 set
    const handleChangeCk = (e) => {
        // 체크된 경우 쿠키값 set
        if(e.target.checked) {
            const time = 3600*24*7; //1시간
            const expiration = new Date(Date.now() + time * 1000);
            setCookie("loggedIn", loginInfo.userId, { path: '/' , expires: expiration });
        }
        // 체크 해제한 경우 쿠키 제거
        else {
            removeCookie("loggedIn"); 
        }
	}

    return (
        <>
          <main className="admin-login">
            <section className="login-inner">
 
              <div className="login-wrap">
                <h1 className="logo"><Link to="/" className="logoArea"><img src={logo} alt="WIPIA" /></Link></h1>
                <form className="needs-validation " noValidate>
                     <div className="login-list">
                       <input type="text" id="userId" onChange={handleChange} name="userId"  required value={loginInfo.userId || ""} placeholder="아이디"/>
                       <div className="invalid-feedback ">아이디를 입력해주세요.</div>
                     </div>
                     <div className="login-list password-list">
                       <div className="password-toggle">
                         <input type="password" id="userPw"  required onChange={handleChange} name="userPw" value={loginInfo.userPw || ""} placeholder="비밀번호"/>
                         <label className="password-toggle-btn" aria-label="Show/hide password">
                           <input className="password-toggle-check" type="checkbox" />
                           {/* <span className="password-toggle-indicator"></span> */}
                         </label>
                         <div className="invalid-feedback">비밀번호를 입력해주세요.</div>
                       </div>
                     </div>
                    <div className="form-check">
                      <input type="checkbox" id="remember" className="form-check-input" onChange={handleChangeCk} checked={cookies.loggedIn!=null}/>
                      <label htmlFor="remember" className="form-check-label ">아이디 저장</label>
                    </div>
                     <button className="login-btn" as="input" type="button" value="로그인"  onClick={fn_login}>로그인</button>
                  </form>

              </div>
              <p className="copyright-text">COPYRIGHT ⓒ 2025 WIPIA CO., LTD. ALL RIGHTS RESERVED. </p>
            </section>
          </main>
        
   
        </>
    );
}

export default AdminLogin;